// Don't include a backslash at the end of an URL
var api_conf = {
  apiURLDEV: 'http://192.168.50.15:8180/v2',
  apiURLPROD: 'http://localhost:8180/v2',
  apiURL: 'https://anfora.deltapos.app/v2'
};

export default api_conf
